"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameForOperation = {
    root: "Cube",
    tetraRoot: "Tetrahedron",
    squareRoot: "Square",
    pop: "Pop",
    pyramid: "Pyramid",
    truncatedPyramid: "Truncated Pyramid",
    bevel: "Bevel",
    jump: "Jump",
    bigPop: "Big Pop",
    smallPop: "Small Pop",
    randomPop: "Random Pop"
};
exports.describeSucessors = (suc) => {
    switch (suc.kind) {
        case "none":
            return "No sucessor rules";
        case "all":
            return `Apply ${suc.rule || "-"} to all faces`;
        case "specific":
            return `Apply [${suc.rules
                .map(r => r || "-")
                .join(", ")}] to faces in turn`;
    }
};



// WEBPACK FOOTER //
// ./src/data/types.ts